import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../Widgets.scss';
import './DebtorWidget.scss';
import InformationCard from '../../shared/InformationCard/InformationCard';
import SupplyWidget from '../SupplyWidget/SupplyWidget';
import Gazprom from '../../assets/img/gaz.png';
import RN from '../../assets/img/rn.png';
import LUC from '../../assets/img/luk.png';

class DebtorWidget extends Component {
  static propTypes = {
    classPrefix: PropTypes.string,
    listDebtors: PropTypes.array,
    roleAcc: PropTypes.string,
    userInfo: PropTypes.object,
    debtWidgetOn: PropTypes.bool,
  }

  constructor(props) {
    super(props)



    this.state = {
      debtWidgetOn: this.props.debtWidgetOn,
      activeDebtorid: null,
      activeDebtor: null,
      supplies2: [
        {
          "id": 1,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "08.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "01.10.2018",
          "delay": "90 ",
          "delayLeft": "83",
          "amount": "4252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3678-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "800000",
              "supplyPriceRate": "91",
              "supplyInformation":
                {
                  "supplyPrice": "987400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-13ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [
                {"supplyAgreement": [
                    {
                      "supplyAgreementNumber": "3678-РН КС",
                      "supplyAgreementDate": "21.07.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    },
                    {
                      "supplyAgreementNumber": "Акт приемки №1-23",
                      "supplyAgreementDate": "29.08.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]},
                {"supplyConfirm": [
                    {
                      "supplyAgreementNumber": "34",
                      "supplyAgreementDate":  "23.09.2018",
                      "debtorCheck": false,
                      "vendorCheck": true
                    }
                  ]},
                {"supplyNetting": [
                    {
                      "supplyAgreementNumber": "12",
                      "supplyAgreementDate": "28.09.2018",
                      "debtorCheck": true,
                      "vendorCheck": true
                    }
                  ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "positoin": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros"
          }
        }
      ],
      supplies:[
        {
          "id": 1,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "12.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "29.09.2018",
          "delay": "90",
          "delayLeft": "83",
          "amount": "41252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "0",
          "supplyAgreementNumber": "3668-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8200000",
              "supplyInformation":
                {
                  "supplyPrice": "1987400",
                  "supplyPriceClose": "1677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "На рассмотрении"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3668-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 2,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "11.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "24.09.2018",
          "delay": "90",
          "delayLeft": "84",
          "amount": "34172000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "1",
          "supplyAgreementNumber": "ГП-2018-567",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3509800",
                  "supplyPriceClose": "12122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-567",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 3,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "10.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "21.09.2018",
          "delay": "210",
          "delayLeft": "129",
          "amount": "43952000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "0",
          "supplyAgreementNumber": "Л-2018.07-45",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "16550000",
              "supplyInformation":
                {
                  "supplyPrice": "32590000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437000",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-45",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 4,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "10.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "11.09.2018",
          "delay": "210",
          "delayLeft": "176",
          "amount": "39752000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "1",
          "supplyAgreementNumber": "3677-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8050000",
              "supplyInformation":
                {
                  "supplyPrice": "11874000",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3677-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 5,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "09.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "19.09.2018",
          "delay": "90",
          "delayLeft": "81",
          "amount": "41140000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "1",
          "supplyAgreementNumber": "ГП-2018-566",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2510000",
              "supplyInformation":
                {
                  "supplyPrice": "3959800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-566",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 6,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "09.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "29.08.2018",
          "delay": "90",
          "delayLeft": "79",
          "amount": "37552000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-54",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-54",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 7,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "09.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "20.09.2018",
          "delay": "90",
          "delayLeft": "83",
          "amount": "34852000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3676-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "1800000",
              "supplyInformation":
                {
                  "supplyPrice": "1987400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3676-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 8,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "08.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "12.09.2018",
          "delay": "210",
          "delayLeft": "188",
          "amount": "48352000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-565",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3059800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-565",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 9,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "08.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "03.09.2018",
          "delay": "210",
          "delayLeft": "149",
          "amount": "411252000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "2",
          "supplyAgreementNumber": "Л-2018.07-53",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-53",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 10,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "05.10.2018",
          "delay": "90",
          "delayLeft": "81",
          "amount": "47252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "2",
          "supplyAgreementNumber": "3675-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8200000",
              "supplyInformation":
                {
                  "supplyPrice": "9887400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3675-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 11,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "07.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "02.10.2018",
          "delay": "90",
          "delayLeft": "84",
          "amount": "38964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-564",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3598000",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-564",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 12,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "03.10.2018",
          "delay": "90",
          "delayLeft": "32",
          "amount": "41265300",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-52",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-52",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 13,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "29.09.2018",
          "delay": "90",
          "delayLeft": "72",
          "amount": "34252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3674-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8000000",
              "supplyInformation":
                {
                  "supplyPrice": "9087400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3674-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 14,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "27.09.2018",
          "delay": "90",
          "delayLeft": "82",
          "amount": "38964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-563",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3059800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-563",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 15,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "22.09.2018",
          "delay": "90",
          "delayLeft": "81",
          "amount": "41265000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-51",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-51",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 16,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "07.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "25.09.2018",
          "delay": "210",
          "delayLeft": "183",
          "amount": "44252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3673-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8300000",
              "supplyInformation":
                {
                  "supplyPrice": "9387400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3673-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 17,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "07.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "23.09.2018",
          "delay": "210",
          "delayLeft": "189",
          "amount": "28964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-562",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3459800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-562",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 18,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "06.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "23.09.2018",
          "delay": "210",
          "delayLeft": "159",
          "amount": "31265000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-50",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "12655000",
              "supplyInformation":
                {
                  "supplyPrice": "13259000",
                  "supplyPriceClose": "17122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-50",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 19,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "06.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "22.09.2018",
          "delay": "90",
          "delayLeft": "81",
          "amount": "40252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3672-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8900000",
              "supplyInformation":
                {
                  "supplyPrice": "9874000",
                  "supplyPriceClose": "26773000",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3672-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 20,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "06.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "02.10.2018",
          "delay": "90",
          "delayLeft": "69",
          "amount": "48964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "2",
          "supplyAgreementNumber": "ГП-2018-561",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3509800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-561",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": false,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 21,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "06.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "29.09.2018",
          "delay": "90",
          "delayLeft": "84",
          "amount": "41250300",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-49",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-49",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 22,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "06.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "01.10.2018",
          "delay": "90",
          "delayLeft": "83",
          "amount": "45252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3671-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8900000",
              "supplyInformation":
                {
                  "supplyPrice": "9987400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3671-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 23,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "06.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "17.09.2018",
          "delay": "90",
          "delayLeft": "84",
          "amount": "38964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-560",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3598000",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-560",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 24,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "05.10.2018",
          "classificator": "Разведочное бурение",
          "dateCompleted": "18.09.2018",
          "delay": "90",
          "delayLeft": "55",
          "amount": "51265000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-48",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Строительство разведочных и поисково-оценочной скважин",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-48",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 2,
          "vendor": {
            "name": "Алексей",
            "sureName": "Володин",
            "middleName": "Михайлович",
            "position": "Генеральный директор",
            "phone": "8 (4912) 308 193",
            "email": "pptkpo@tkpo.ryazan.ru",
            "site": "tkpo.ryazan.ru",
            "address": "390042, Россия, Рязань, Промышленная, 5",
            "avatar": "volodin",
            "logo": "tpm",
            "nameCompany": "ТяжПрессМаш ОАО"
          }
        },
        {
          "id": 25,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "05.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "25.09.2018",
          "delay": "210",
          "delayLeft": "199",
          "amount": "42252000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3670-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "800000",
              "supplyInformation":
                {
                  "supplyPrice": "987400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3670-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 26,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "05.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "07.09.2018",
          "delay": "90",
          "delayLeft": "81",
          "amount": "38964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-559",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3590800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-559",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 27,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "04.10.2018",
          "classificator": "Проектные работы в области энергетики",
          "dateCompleted": "03.09.2018",
          "delay": "90",
          "delayLeft": "72",
          "amount": "44265000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-47",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Проектирование, изготовление и поставка трансформаторной подстанции",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-47",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 3,
          "vendor": {
            "name": "Владимир",
            "sureName": "Шестериков",
            "middleName": "Савельевич",
            "position": "Генеральный директор",
            "phone": "8 (495) 2 257 595",
            "email": "cck@sibserv.com",
            "site": "sibserv.com",
            "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
            "avatar": "shestakov",
            "logo": "sibserv",
            "nameCompany": "Сибирская Сервисная Компания АО"
          }
        },
        {
          "id": 28,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "04.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "28.09.2018",
          "delay": "90",
          "delayLeft": "82",
          "amount": "41152000",
          "nameCompany": "РН-Уватнефтегаз ООО",
          "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
          "verification": "3",
          "supplyAgreementNumber": "3669-РН КС",
          "supplyAgreementDate": "21.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "31",
              "supplyPriceFinal": "8000000",
              "supplyInformation":
                {
                  "supplyPrice": "9087400",
                  "supplyPriceClose": "2677300",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "2797000",
                  "supplyNumber": "92-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Договор №3669-РН КС",
                    "supplyAgreementDate": "21.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  },
                  {
                    "supplyAgreementNumber": "Приложение №1",
                    "supplyAgreementDate": "29.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "23.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №12",
                    "supplyAgreementDate": "28.09.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 1,
          "debtor": {
            "name": "Игорь",
            "sureName": "Онешко",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (3452) 38 22 97",
            "email": "rn-uvatng@uvng.rosneft.ru",
            "site": "ung.rosneft.ru",
            "address": "625000, г. Тюмень, ул. Ленина,67",
            "avatar": "oneshko",
            "logo": "rn",
            "nameCompany": "РН-Уватнефтегаз ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 29,
          "basket": false,
          "offer": false,
          "statusSupply": "active",
          "datePlace": "04.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "19.09.2018",
          "delay": "90",
          "delayLeft": "83",
          "amount": "37964000",
          "nameCompany": "Газпром добыча Уренгой ООО",
          "companyGroup": {"icon": "gaz", "txt": "Газпром"},
          "verification": "3",
          "supplyAgreementNumber": "ГП-2018-558",
          "supplyAgreementDate": "01.05.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2500000",
              "supplyInformation":
                {
                  "supplyPrice": "3590800",
                  "supplyPriceClose": "2122900",
                  "supplyPriceReceivables": "0",
                  "supplyPriceNetting": "0",
                  "supplyNumber": "93-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "ГП-2018-558",
                    "supplyAgreementDate": "01.05.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №34",
                    "ssupplyAgreementDate":  "01.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №56",
                    "supplyAgreementDate": "05.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 2,
          "debtor": {
            "name": "Александр",
            "sureName": "Корякин",
            "middleName": "Юрьевич",
            "position": "Генеральный директор",
            "phone": "8 (3494) 948 409",
            "email": "gdu@gd-urengoy.gazprom.ru",
            "site": "urengoy-dobycha.gazprom.ru",
            "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
            "avatar": "koryakin",
            "logo": "gaz",
            "nameCompany": "Газпром добыча Уренгой ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        },
        {
          "id": 30,
          "basket": false,
          "offer": false,
          "statusSupply": "deactive",
          "datePlace": "03.10.2018",
          "classificator": "Инженерно-геологические изыскания",
          "dateCompleted": "02.10.2018",
          "delay": "210",
          "delayLeft": "189",
          "amount": "45650000",
          "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
          "companyGroup": "luc",
          "verification": "3",
          "supplyAgreementNumber": "Л-2018.07-46",
          "supplyAgreementDate": "12.07.2018",
          "supplyMore":
            {
              "supplyName": "Сервисное сопровождение буровых растворов на УГПК-9",
              "supplyInterestRate": "20",
              "supplyPriceFinal": "2655000",
              "supplyInformation":
                {
                  "supplyPrice": "3259000",
                  "supplyPriceClose": "7122900",
                  "supplyPriceReceivables": "20899",
                  "supplyPriceNetting": "437050",
                  "supplyNumber": "94-18ФСТ",
                  "supplyStatus": "Сбор денег"
                },
              "supplyDocuments": [{
                "supplyAgreement": [
                  {
                    "supplyAgreementNumber": "Л-2018.07-46",
                    "supplyAgreementDate": "12.07.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyConfirm": [
                  {
                    "supplyAgreementNumber": "Акт выполненных работ №95",
                    "ssupplyAgreementDate":  "16.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]},{
                "supplyNetting": [
                  {
                    "supplyAgreementNumber": "Акт сверки №9",
                    "supplyAgreementDate": "21.08.2018",
                    "debtorCheck": true,
                    "vendorCheck": true
                  }
                ]}
              ]
            },
          "idDebtor": 3,
          "debtor": {
            "name": "Сергей",
            "sureName": "Кочкуров",
            "middleName": "Алексеевич",
            "position": "Генеральный директор",
            "phone": "8 (34667) 2 98 00",
            "email": "ws@lukoil.com",
            "site": "zs.lukoil.ru",
            "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
            "avatar": "kochkurov",
            "logo": "luk",
            "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО"
          },
          "idVendor": 1,
          "vendor": {
            "name": "Андрей",
            "sureName": "Королев",
            "middleName": "Владимирович",
            "position": "Генеральный директор",
            "phone": "8 (499) 941 09 04",
            "email": "info@akros-llc.com",
            "site": "akros-llc.com",
            "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
            "avatar": "korolev",
            "logo": "akros",
            "nameCompany": "Акрос ООО"
          }
        }
      ] // GOVNOKOD
    }
  }

  componentWillUnmount() {
    this.state = {
      activeDebtorid: null,
      activeDebtor: null,
    }
  }



  handleUserSelect = (id) => {
    const {supplies} = this.state;
    const {roleAcc} = this.props;

    supplies.map(item => {
      roleAcc === 'debtor' ?
      item.idDebtor === id &&
        this.setState({
          activeDebtor: item,
          activeDebtorid: id,
        }) : item.idVendor === id &&
        this.setState({
          activeDebtor: item,
          activeDebtorid: id,
        })
    })
    this.setState({debtWidgetOn: false});
  };

  get accountInfo() {
    const {activeDebtor} = this.state;
    const {roleAcc, listDebtors} = this.props;

    return (
      <div className={'accountCard'}>
        <InformationCard viewType={'full'}
                         roleUser={roleAcc}
                         supply={activeDebtor}
                         additionalInfo={listDebtors}/>
      </div>
    )
  }
  setBasket = count => {
    this.setState({
      basketCnt: count,
    })
  }
  get listAccounts() {
    const {listDebtors} = this.props;
    return (
      <div style={{height: '100%'}}>
      <div className={'header'}>
        <div className={'item'}>
          <div className={'dark'}>Название</div>
          <div className={'light'}> юр. лица</div>
        </div>
        <div className={'item'}>
          <div className={'dark'}>Группа</div>
          <div className={'light'}> компаний</div>
        </div>
        <div className={'item'}>
          <div className={'dark'}>Сумма</div>
          <div className={'light'}>поставок руб</div>
        </div>
        <div className={'item'}>
          <div className={'dark'}>Число</div>
          <div className={'light'}>поставок шт.</div>
        </div>
        <div className={'item'}>
          <div className={'dark'}>Отчетность</div>
          <div className={'light'}>наличие отчетности</div>
        </div>
      </div>
    {listDebtors.map((user, i) => {
      return (<div key={`userlist${i}`} className={'row'} onClick={() => this.handleUserSelect(user.id, i)}>
        <div className={'item'}><span>
              {user.companyGroup.icon === 'rn' ?
                <img src={RN} alt={''} /> :
                user.companyGroup.icon === 'gaz' ?
                  <img src={Gazprom} alt={''}/> :
                  <img src={LUC} alt={''} width={25} height={25}/>
              }
        </span><div>{user.nameCompany}</div></div>
        <div className={'item'}>
          <span>
           {user.companyGroup.icon === 'rn' ?
             <img src={RN} alt={''} /> :
             user.companyGroup.icon === 'gaz' ?
               <img src={Gazprom} alt={''}/> :
               <img src={LUC} alt={''} width={25} height={25}/>
           }
            </span>
          <div className={'item'}>{user.companyGroup.txt}</div></div>
        <div className={'item'}>{user.amountAll}</div>
        <div className={'item'}>{user.supplyAll}</div>
        <div className={'item'}>{user.report}/5</div>
      </div>)
    })}
    </div>
    )
  }

  render() {
    const {classPrefix, roleAcc} = this.props;
    const {activeDebtor, debtWidgetOn} = this.state;
    console.log(debtWidgetOn)
    return (<div className={`contentBody${classPrefix}`}>
      <div className={'widgetTitle'}>
        {roleAcc === 'debtor' ? activeDebtor ? 'Дебитор' : 'Дебиторы' :
          activeDebtor ? 'Поставщик' : 'Поставщики'}
    </div>
      {activeDebtor && !debtWidgetOn ? (
        <div className={'withTable'}>
          <div className={'accInfo'}>
            {this.accountInfo}
          </div>
          <SupplyWidget
            basketCnt={this.setBasket}
            classPrefix={''}
            isBasket={false}
            userInfo={this.props.userInfo}
            inAccounts={true}
            accountId={[roleAcc, activeDebtor]}/>
        </div>
        ) : (
          <div className={'debtorWidget'}>
          {this.listAccounts}
        </div>)
  }</div>)

}}

export default DebtorWidget;



// WEBPACK FOOTER //
// ./src/Widget/DebtorWidget/DebtorWidget.js